import React, { Fragment } from "react";

import Design from "./designs/Design";
import { getImageSliderTemplates } from "./image-slider-templates";
import { DesignContainer, OverviewDesignContainer } from "./designs/styles";
import { useImageSliderStore } from "../../../../../../stores/use-image-slider-store";
import { useOpticsStore } from "../../../../../../stores/use-optics-store";
import {
  ImageSliderTemplatesContainer,
  Divider,
  OverviewImageSlidersTemplatesContainer,
} from "./styles";
import { MACRO_KEY } from "../../../../../defaults";

export const OverviewTemplates = () => {
  const { data, setData } = useImageSliderStore((state) => ({
    data: state.data,
    setData: state.setData,
  }));

  const { setDrawers, styleguideSetup, setMacro } = useOpticsStore((state) => ({
    setDrawers: state.setDrawers,
    styleguideSetup: state.styleguideSetup,
    setMacro: state.setMacro,
  }));

  const templates = getImageSliderTemplates(styleguideSetup);

  return (
    <OverviewImageSlidersTemplatesContainer>
      {templates.map((template, index) => (
        <Fragment key={template.design}>
          <OverviewDesignContainer
            borderRadius={styleguideSetup.cornerRadius}
            isSelected={data.design === template.design}
            hasHover
            onClick={() => {
              setMacro({ key: MACRO_KEY.IMAGE_SLIDER });
              setData(template);
              setDrawers({ templates: false, settings: true });
            }}
          >
            <Design data={template} isPreview />
          </OverviewDesignContainer>
          {index < templates.length - 1 && <Divider />}
        </Fragment>
      ))}
    </OverviewImageSlidersTemplatesContainer>
  );
};

const ImageSliderTemplates = () => {
  const { data, setData } = useImageSliderStore((state) => ({
    data: state.data,
    setData: state.setData,
  }));

  const { setDrawers, styleguideSetup } = useOpticsStore((state) => ({
    setDrawers: state.setDrawers,
    styleguideSetup: state.styleguideSetup,
  }));

  const hasData = !!Object.keys(data).length;
  const templates = getImageSliderTemplates(styleguideSetup);

  return (
    <ImageSliderTemplatesContainer>
      {templates.map((template) => (
        <DesignContainer
          isSelected={data.design === template.design}
          borderRadius={styleguideSetup.cornerRadius}
          hasHover
          onClick={() => {
            if (hasData) {
              setData({
                ...data,
                images: data.images,
                design: template.design,
                hasImagesTitle: template.hasImagesTitle,
                hasImagesDescription: template.hasImagesDescription,
              });
            } else {
              setData(template);
            }
            setDrawers({ templates: false, settings: true });
          }}
        >
          <Design data={template} isPreview />
        </DesignContainer>
      ))}
    </ImageSliderTemplatesContainer>
  );
};

export default ImageSliderTemplates;
